import { numberToCompactCurrency, semanticColors } from '@/utils'

const MERCHANT_ROWS = [
  { name: 'Payroll Co.', amount: 4200 },
  { name: 'Amazon', amount: -2340 },
  { name: 'Whole Foods', amount: -1180 },
  { name: 'Uber', amount: -620 },
] as const

const MERCHANT_MAX_AMOUNT = Math.max(
  ...MERCHANT_ROWS.map((row) => Math.abs(row.amount)),
)

export const MerchantsPreview = () => {
  return (
    <div className="flex h-full w-full flex-col justify-between gap-1 text-[10px]">
      {MERCHANT_ROWS.map((row) => {
        const isInflow = row.amount >= 0
        const widthPct = (Math.abs(row.amount) / MERCHANT_MAX_AMOUNT) * 100
        return (
          <div
            key={row.name}
            className="grid grid-cols-[54px_minmax(0,1fr)_auto] items-center gap-2"
          >
            <span className="truncate text-foreground">{row.name}</span>
            <div className="h-2 w-full">
              <div
                className="h-full rounded-sm"
                style={{
                  width: `${widthPct}%`,
                  backgroundColor: isInflow
                    ? semanticColors.inflow
                    : semanticColors.outflow,
                }}
              />
            </div>
            <span className="shrink-0 tabular-nums text-muted-foreground">
              {numberToCompactCurrency(row.amount)}
            </span>
          </div>
        )
      })}
    </div>
  )
}
